var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "qm-picture-library-img-cutter" },
    [
      _vm.showChooseBtn === true && _vm.isModal === true
        ? _c(
            "div",
            { on: { click: _vm.handleOpen } },
            [_vm._t("openImgCutter"), _vm._t("open")],
            2
          )
        : _vm._e(),
      !_vm.$slots.openImgCutter && !_vm.$slots.open && _vm.isModal === true
        ? _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "button" },
              on: { click: _vm.handleOpen },
            },
            [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
          )
        : _vm._e(),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.visible
          ? _c(
              "div",
              {
                ref: "mask",
                class: _vm.isModal === true ? "mask vue-img-cutter" : "",
              },
              [
                _vm.visible
                  ? _c(
                      "div",
                      {
                        class:
                          _vm.isModal === true ? "dialogBoxModal" : "dialogBox",
                      },
                      [
                        _c(
                          "transition",
                          {
                            attrs: {
                              name: "fade",
                              "enter-class": "fade-in-enter",
                              "enter-active-class": "fade-in-active",
                              "leave-class": "fade-out-enter",
                              "leave-active-class": "fade-out-active",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                ref: "dialogMainModalRef",
                                class:
                                  _vm.isModal === true
                                    ? "dialogMainModal"
                                    : "dialogMain",
                                style:
                                  "width:" +
                                  (_vm.isModal === true
                                    ? _vm.boxWidth + 32
                                    : _vm.boxWidth) +
                                  "px",
                              },
                              [
                                _c("div", { staticClass: "toolMain" }, [
                                  _vm.isModal === true
                                    ? _c("div", { staticClass: "tool-title" }, [
                                        _vm._v(
                                          "\n                图片裁剪\n                "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "closeIcon",
                                            on: { click: _vm.handleClose },
                                          },
                                          [_vm._v("×")]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      ref: "toolBox",
                                      staticClass: "toolBox",
                                      style:
                                        "height:" +
                                        _vm.boxHeight +
                                        "px;width:" +
                                        _vm.boxWidth +
                                        "px",
                                      on: {
                                        mousemove: _vm.controlBtnMouseMove,
                                        mouseup: _vm.controlBtnMouseUp,
                                        mouseleave: _vm.controlBtnMouseUp,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                !_vm.drawImg.img &&
                                                _vm.showChooseBtn === true,
                                              expression:
                                                "!drawImg.img && showChooseBtn === true",
                                            },
                                          ],
                                          staticClass: "tips",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "btn btn-warning btn-xs",
                                              on: { click: _vm.chooseImg },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(_vm.label) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm.tool == true
                                        ? _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.drawImg.img &&
                                                    _vm.dropImg.active !==
                                                      true &&
                                                    _vm.controlBox.disable ==
                                                      true &&
                                                    _vm.toolBox.disable == true,
                                                  expression:
                                                    "\n                    drawImg.img && dropImg.active !== true && controlBox.disable == true && toolBox.disable == true\n                  ",
                                                },
                                              ],
                                              staticClass: "dockMain",
                                              style:
                                                "background:" + _vm.toolBgc,
                                              on: {
                                                mouseenter: _vm.dropImgOff,
                                              },
                                            },
                                            [
                                              _vm.rate
                                                ? _c(
                                                    "div",
                                                    { staticClass: "dockBtn" },
                                                    [
                                                      _vm._t("ratio", [
                                                        _vm._v(" Ratio: "),
                                                      ]),
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(_vm.rate) +
                                                          "\n                  "
                                                      ),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "dockBtn",
                                                  on: { click: _vm.scaleReset },
                                                },
                                                [
                                                  _vm._t("scaleReset", [
                                                    _vm._v(" Scale: "),
                                                  ]),
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.drawImg.swidth > 0
                                                          ? (
                                                              _vm.drawImg
                                                                .width /
                                                              _vm.drawImg.swidth
                                                            ).toFixed(2)
                                                          : "-"
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ],
                                                2
                                              ),
                                              _vm.originalGraph === false
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "dockBtn",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.turnImg(-90)
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._t("turnLeft", [
                                                        _vm._v(" ↳ "),
                                                      ]),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm.originalGraph === false
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "dockBtn",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.turnImg(90)
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._t("turnRight", [
                                                        _vm._v(" ↲ "),
                                                      ]),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm.originalGraph === false
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "dockBtn",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.turnReset()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._t("reset", [
                                                        _vm._v(" ↻ "),
                                                      ]),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm.originalGraph === false
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dockBtnScrollBar",
                                                    },
                                                    [
                                                      _c("div", {
                                                        ref: "dockBtnScrollControl",
                                                        staticClass:
                                                          "scrollBarControl",
                                                        style:
                                                          "left:" +
                                                          _vm.rotateControl
                                                            .position +
                                                          "px",
                                                        on: {
                                                          mousemove:
                                                            _vm.scrollBarControlMove,
                                                          mousedown:
                                                            _vm.scrollBarControlOn,
                                                          mouseleave:
                                                            _vm.scrollBarControlOff,
                                                          mouseup:
                                                            _vm.scrollBarControlOff,
                                                        },
                                                      }),
                                                      _vm.rotateControl
                                                        .active == true
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "scrollBarText",
                                                              style:
                                                                "left:" +
                                                                _vm
                                                                  .rotateControl
                                                                  .position +
                                                                "px",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      " +
                                                                  _vm._s(
                                                                    _vm.rotateImg.angle.toFixed(
                                                                      0
                                                                    ) + "°"
                                                                  ) +
                                                                  "\n                    "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.originalGraph === false
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "dockBtn",
                                                      on: {
                                                        click:
                                                          _vm.flipHorizontal,
                                                      },
                                                    },
                                                    [
                                                      _vm._t("flipHorizontal", [
                                                        _vm._v(" ⇆ "),
                                                      ]),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm.originalGraph === false
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "dockBtn",
                                                      on: {
                                                        click:
                                                          _vm.flipVertically,
                                                      },
                                                    },
                                                    [
                                                      _vm._t("turnRight", [
                                                        _vm._v(" ⇅ "),
                                                      ]),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.drawImg.img != null,
                                              expression: "drawImg.img != null",
                                            },
                                          ],
                                          ref: "toolBoxControl",
                                          staticClass: "toolBoxControl",
                                          on: {
                                            mousedown: _vm.toolBoxMouseDown,
                                            mouseup: _vm.toolBoxMouseUp,
                                            mousemove: _vm.toolBoxMouseMove,
                                            mouseleave: _vm.toolBoxMouseLeave,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "toolBoxControlBox",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "controlBox" },
                                                [
                                                  _c("div", {
                                                    staticClass:
                                                      "controlBoxInnerLine controlBoxInnerLineTop",
                                                  }),
                                                  _c("div", {
                                                    staticClass:
                                                      "controlBoxInnerLine controlBoxInnerLineBottom",
                                                  }),
                                                  _c("div", {
                                                    staticClass:
                                                      "controlBoxInnerLine controlBoxInnerLineLeft",
                                                  }),
                                                  _c("div", {
                                                    staticClass:
                                                      "controlBoxInnerLine controlBoxInnerLineRight",
                                                  }),
                                                  _vm.originalGraph === false
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "selectArea",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        宽:" +
                                                              _vm._s(
                                                                _vm.toolBox
                                                                  .width
                                                              ) +
                                                              " 高:" +
                                                              _vm._s(
                                                                _vm.toolBox
                                                                  .height
                                                              ) +
                                                              " (x:" +
                                                              _vm._s(
                                                                _vm
                                                                  .toolBoxPosition
                                                                  .x
                                                              ) +
                                                              ",y:" +
                                                              _vm._s(
                                                                _vm
                                                                  .toolBoxPosition
                                                                  .y
                                                              ) +
                                                              ")\n                      "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.originalGraph === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "selectArea",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        宽:" +
                                                              _vm._s(
                                                                (
                                                                  _vm.toolBox
                                                                    .width /
                                                                  (_vm.drawImg
                                                                    .width /
                                                                    _vm.drawImg
                                                                      .swidth)
                                                                ).toFixed(0)
                                                              ) +
                                                              " 高:" +
                                                              _vm._s(
                                                                (
                                                                  _vm.toolBox
                                                                    .height /
                                                                  (_vm.drawImg
                                                                    .width /
                                                                    _vm.drawImg
                                                                      .swidth)
                                                                ).toFixed(0)
                                                              ) +
                                                              "\n                        (x:" +
                                                              _vm._s(
                                                                _vm
                                                                  .toolBoxPosition
                                                                  .x
                                                              ) +
                                                              ",y:" +
                                                              _vm._s(
                                                                _vm
                                                                  .toolBoxPosition
                                                                  .y
                                                              ) +
                                                              ")\n                      "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.sizeChange === true
                                                    ? _c("div", {
                                                        staticClass:
                                                          "leftUp controlBtn",
                                                        attrs: {
                                                          "data-name": "leftUp",
                                                        },
                                                        on: {
                                                          mousedown: function (
                                                            $event
                                                          ) {
                                                            _vm.controlBtnMouseDown(
                                                              $event,
                                                              "leftUp"
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm.sizeChange === true
                                                    ? _c("div", {
                                                        staticClass:
                                                          "leftDown controlBtn",
                                                        attrs: {
                                                          "data-name":
                                                            "leftDown",
                                                        },
                                                        on: {
                                                          mousedown: function (
                                                            $event
                                                          ) {
                                                            _vm.controlBtnMouseDown(
                                                              $event,
                                                              "leftDown"
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm.sizeChange === true
                                                    ? _c("div", {
                                                        staticClass:
                                                          "rightUp controlBtn",
                                                        attrs: {
                                                          "data-name":
                                                            "rightUp",
                                                        },
                                                        on: {
                                                          mousedown: function (
                                                            $event
                                                          ) {
                                                            _vm.controlBtnMouseDown(
                                                              $event,
                                                              "rightUp"
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm.sizeChange === true
                                                    ? _c("div", {
                                                        staticClass:
                                                          "rightDown controlBtn",
                                                        attrs: {
                                                          "data-name":
                                                            "rightDown",
                                                        },
                                                        on: {
                                                          mousedown: function (
                                                            $event
                                                          ) {
                                                            _vm.controlBtnMouseDown(
                                                              $event,
                                                              "rightDown"
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm.sizeChange === true &&
                                                  !_vm.rate &&
                                                  _vm.toolBox.width > 20
                                                    ? _c("div", {
                                                        staticClass:
                                                          "topCenter controlBtn",
                                                        attrs: {
                                                          "data-name":
                                                            "topCenter",
                                                        },
                                                        on: {
                                                          mousedown: function (
                                                            $event
                                                          ) {
                                                            _vm.controlBtnMouseDown(
                                                              $event,
                                                              "topCenter"
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm.sizeChange === true &&
                                                  !_vm.rate &&
                                                  _vm.toolBox.width > 20
                                                    ? _c("div", {
                                                        staticClass:
                                                          "downCenter controlBtn",
                                                        attrs: {
                                                          "data-name":
                                                            "downCenter",
                                                        },
                                                        on: {
                                                          mousedown: function (
                                                            $event
                                                          ) {
                                                            _vm.controlBtnMouseDown(
                                                              $event,
                                                              "downCenter"
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm.sizeChange === true &&
                                                  !_vm.rate &&
                                                  _vm.toolBox.height > 20
                                                    ? _c("div", {
                                                        staticClass:
                                                          "leftCenter controlBtn",
                                                        attrs: {
                                                          "data-name":
                                                            "leftCenter",
                                                        },
                                                        on: {
                                                          mousedown: function (
                                                            $event
                                                          ) {
                                                            _vm.controlBtnMouseDown(
                                                              $event,
                                                              "leftCenter"
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm.sizeChange === true &&
                                                  !_vm.rate &&
                                                  _vm.toolBox.height > 20
                                                    ? _c("div", {
                                                        staticClass:
                                                          "rightCenter controlBtn",
                                                        attrs: {
                                                          "data-name":
                                                            "rightCenter",
                                                        },
                                                        on: {
                                                          mousedown: function (
                                                            $event
                                                          ) {
                                                            _vm.controlBtnMouseDown(
                                                              $event,
                                                              "rightCenter"
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ]
                                              ),
                                              _c("div", {
                                                staticClass:
                                                  "toolBoxControlLine toolBoxControlLineItem-1",
                                              }),
                                              _c("div", {
                                                staticClass:
                                                  "toolBoxControlLine toolBoxControlLineItem-2",
                                              }),
                                              _c("div", {
                                                staticClass:
                                                  "toolBoxControlLine toolBoxControlLineItem-3",
                                              }),
                                              _c("div", {
                                                staticClass:
                                                  "toolBoxControlLine toolBoxControlLineItem-4",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c("div", { staticClass: "copyright" }),
                                      _c("canvas", {
                                        ref: "canvasSelectBox",
                                        staticClass: "canvasSelectBox",
                                        attrs: {
                                          width: _vm.boxWidth,
                                          height: _vm.boxHeight,
                                        },
                                        on: {
                                          mousedown: _vm.dropImgOn,
                                          mouseup: _vm.dropImgOff,
                                          mousemove: _vm.dropImgMove,
                                        },
                                      }),
                                      _c("canvas", {
                                        ref: "canvas",
                                        staticClass: "canvas",
                                        attrs: {
                                          width: _vm.boxWidth,
                                          height: _vm.boxHeight,
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "i-dialog-footer" }, [
                                  _c("input", {
                                    ref: "inputFile",
                                    staticStyle: {
                                      width: "1px",
                                      height: "1px",
                                      border: "none",
                                      opacity: "0",
                                    },
                                    attrs: {
                                      type: "file",
                                      accept:
                                        "image/gif, image/jpeg ,image/png",
                                    },
                                    on: { change: _vm.putImgToCanv },
                                  }),
                                  _c(
                                    "span",
                                    { on: { click: _vm.chooseImg } },
                                    [
                                      _vm._t("choose", [
                                        _vm.showChooseBtn === true
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "btn btn-primary btn-primary-plain",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(_vm.label) +
                                                    "\n                  "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ],
                                    2
                                  ),
                                  _c("div", { staticClass: "btn-group fr" }, [
                                    _c(
                                      "span",
                                      { on: { click: _vm.handleClose } },
                                      [
                                        _vm._t("cancel", [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-default",
                                              attrs: { type: "button" },
                                            },
                                            [_vm._v("取消")]
                                          ),
                                        ]),
                                      ],
                                      2
                                    ),
                                    _c(
                                      "span",
                                      {
                                        on: {
                                          click: function ($event) {
                                            _vm.cropPicture(false)
                                          },
                                        },
                                      },
                                      [
                                        _vm._t("confirm", [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-primary",
                                              staticStyle: {
                                                "margin-left": "15px",
                                              },
                                              attrs: {
                                                type: "button",
                                                disabled: !_vm.drawImg.img,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      确定\n                    "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ]
                        ),
                        _c("div", { staticStyle: { clear: "both" } }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }